import { render, staticRenderFns } from "./ProviderIntegrations.vue?vue&type=template&id=9881f7e2&scoped=true&"
import script from "./ProviderIntegrations.vue?vue&type=script&lang=js&"
export * from "./ProviderIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./ProviderIntegrations.vue?vue&type=style&index=0&id=9881f7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9881f7e2",
  null
  
)

export default component.exports